import { useLang } from '@/i18n';
import Trusted from './Trusted';
import css from './index.module.scss';
import { useOnceInView } from './useOnceInView';

function TheComp() {
    const { t } = useLang('powerbackup');

    const list1 = [
        'https://websiteoss.ecoflow.com/figma-uploads/1785724538512-t0ydbf-compressed-Frame%201612707900.webp',
        'https://websiteoss.ecoflow.com/figma-uploads/1785724556853-hokwff-compressed-Frame%201612707900.webp',
        'https://websiteoss.ecoflow.com/figma-uploads/1785724644709-3aperg-compressed-Frame%201612707900.webp',
        'https://websiteoss.ecoflow.com/figma-uploads/1785724649764-t5veua-compressed-Frame%201612707900.webp',
        'https://websiteoss.ecoflow.com/figma-uploads/1785724686563-s3mye4-compressed-Frame%201612707900.webp',
        'https://websiteoss.ecoflow.com/figma-uploads/1785724704197-fhmn4v-compressed-Frame%201612707900.webp',
        'https://websiteoss.ecoflow.com/figma-uploads/1786085163482-tuz651-compressed-Frame%201612707900.webp',
        'https://websiteoss.ecoflow.com/figma-uploads/1786085169520-mxeo6y-compressed-Frame%201612707900.webp',
    ];
    const list2 = [
        'https://websiteoss.ecoflow.com/figma-uploads/1785724574365-bd2ree-compressed-Frame%201612707900.webp',
        'https://websiteoss.ecoflow.com/figma-uploads/1785724588385-u17lqk-compressed-Frame%201612707900.webp',
        'https://websiteoss.ecoflow.com/figma-uploads/1785724721266-100tp4-compressed-Frame%201612707900.webp',
        'https://websiteoss.ecoflow.com/figma-uploads/1785724723227-sw20r6-compressed-Frame%201612707900.webp',
        'https://websiteoss.ecoflow.com/figma-uploads/1785724726014-fpnyit-compressed-Frame%201612707900.webp',
        'https://websiteoss.ecoflow.com/figma-uploads/1785724730802-lqdhoj-compressed-Frame%201612707900.webp',
    ];

    useOnceInView('.power-backup-J .J-title', () => {
        document.querySelector('.power-backup-J .J-title')?.classList.add('enter');
        document.querySelector('.power-backup-J .J-desc')?.classList.add('enter');
        document.querySelector('.power-backup-J .J-Trusted-1')?.classList.add('enter');
        document.querySelector('.power-backup-J .J-Trusted-2')?.classList.add('enter');
    });

    return (
        <section
            className={`${css.section} power-backup-J GtmModuleData-section`}
            id="power-backup-J"
            data-section-id="power-backup-J"
            data-section-title={t('trusted_users_title')}
        >
            <div className="J-title ani-1">{t('trusted_users_title')}</div>
            <div className="J-desc ani-2">{t('trusted_users_desc')}</div>
            <Trusted className="J-Trusted-1 ani-3" title={t('trusted_users_awards_title')} list={list1} />
            <Trusted className="J-Trusted-2 ani-4" title={t('trusted_users_partners_title')} list={list2} />
        </section>
    );
}

export default TheComp;
